import { Component, OnInit, ViewChild,Renderer2} from '@angular/core';
import { DataTableDirective } from "angular-datatables";
import {  Subject } from "rxjs";
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';

import * as _ from 'lodash';
import { TaskService } from 'src/app/services/task.service';
import { RecipientService } from 'src/app/services/recipient.service';
import { AlertComponent } from '../../alert/alert.component';
declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'app-upsi-recipient',
  templateUrl: './upsi-recipient.component.html',
  styleUrls: ['./upsi-recipient.component.css']
})
export class UpsiRecipientComponent implements OnInit {

  public environmentSettings: any;
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtSharerList: DataTables.Settings = {};
    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();
    dtRecipientHistory: DataTables.Settings = {};

    dtHistoryTrigger: Subject<any> = new Subject();
    response: boolean;
    recipientIdforDeleteRecipient: any;
    dtnotInsertdata: DataTables.Settings = {};
    dtnotInsertdataTrigger: Subject<any> = new Subject();
    recipientName: any;
    recipientEmpCode: any;
    recipientDesignation: any;
    recipientUniqueIdentifier: any;
    recipientDocument: any;
    recipientEmail: any;
    disableSelect: any;
    recipientHistory: any;
    SearchDateFrom: any;
    SearchDateTo: any;
    filesToUpload: any;
    fileSizeError: any;
    fileExtension: any;
    fileExtensionError: any;
    isUploadNotValid: boolean;
    notinserteddata: any;
    tmpListener: any;
    fileNameArray: Array<any> = []
    isSearchDivVisible = false;
    isShowEncryptedPAN : boolean=false;
    isShowUnapproved : boolean=false;
    isMakerCheckerUsed =  environment.IsUPSIMakerCheckerUsed
    private isInitializingDataTable: boolean = false;

    constructor(
      private router: Router,
      private alert: AlertComponent,
      private commonFunction: CommonFunction,
      private renderer: Renderer2,
    //   private sharerService: SharerService,
      private taskService: TaskService,
      private route: ActivatedRoute,
      private recipientService: RecipientService
    ) {
        this.response = false;
    }

    ngOnDestroy() {
        this.tmpListener();
    }

    handleCheckboxChange() {
        this.getRecipientList({});
    }

    onDateFromChange(datepicker: any) {
        // Close the calendar when date value changes (after date selection)
        if (datepicker && typeof datepicker.close === 'function' && this.SearchDateFrom) {
            // Use setTimeout to ensure the date selection is complete before closing
            setTimeout(() => {
                datepicker.close();
            }, 200);
        }
    }

    onDateToChange(datepicker: any) {
        // Close the calendar when date value changes (after date selection)
        if (datepicker && typeof datepicker.close === 'function' && this.SearchDateTo) {
            // Use setTimeout to ensure the date selection is complete before closing
            setTimeout(() => {
                datepicker.close();
            }, 200);
        }
    }
    ngOnInit() {
        var $ = jQuery.noConflict();
        this.isShowUnapproved =  false;
        this.isShowEncryptedPAN= true;
        $("body").removeClass("dashboard-page");
        this.fileSizeError = false;
        this.isUploadNotValid = true;
        this.environmentSettings = environment;
        this.recipientUniqueIdentifier = '';
        this.dtRecipientHistory = {
            processing: true,
            serverSide: false,
            scrollX: true,
            deferRender: true,
            stateSave: true,
            stateDuration: -1,
            scrollY: "420px",
            scrollCollapse: true,
            destroy: true,
            pagingType: 'full_numbers',
            paging: true,
            pageLength: 10,
            search: true,
            order: [21, 'desc'],
            lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
            dom: 'lBfrtip',//'Bfrtip',
            buttons: [
                {
                    text: '<i class="fa fa-files-o"></i> Export to Excel',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Recipient History List',
                    title: 'Recipient History List',
                    extend: 'excel',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,21],
                        format: {
                          body: function ( data, row, column, node ) {
                              if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                                if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                              }else{ return data }
                            }
                        }
                    },
                },
                {
                    text: '<i class="fa fa-files-o"></i> Export to PDF',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Recipient History List',
                    title: 'Recipient History List',
                    extend: 'pdf',
                    orientation: 'landscape',
                    pageSize: 'A2',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,21]
                    }
                }
            ]

        }

        this.dtnotInsertdata = {
            processing: true,
            serverSide: false,
            scrollX: true,
            deferRender: true,
            stateSave: true,
            stateDuration: -1,
            scrollY: "420px",
            scrollCollapse: true,
            destroy: true,
            pagingType: 'full_numbers',
            paging: true,
            pageLength: 10,
            search: true,
            order: [0, 'asc'],
            lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
            dom: 'lBfrtip',//'Bfrtip',
            buttons: [
                {
                    text: '<i class="fa fa-files-o"></i> Export to Upload Again',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Not Inserted Records',
                    extend: 'excel',
                    title: '',
                    exportOptions: {
                        columns: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,17],
                        format: {
                          body: function ( data, row, column, node ) {
                              if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                                if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                              }else{ return data }
                            }
                        }
                    },
                }
            ]

        }

    }
    ngAfterViewInit(): void {
        // Initialize DataTable after view is initialized and DOM is ready
        setTimeout(() => {
            this.getRecipientList({});
        }, 0);
        
        this.tmpListener =  this.renderer.listen('document', 'click', (event) => {
            if (event.target.hasAttribute("update-recipient")) {
                this.editRecipientByID(event.target.getAttribute("update-recipient"));

            }
            if (event.target.hasAttribute("delete-recipient")) {
                // console.log(event.target.getAttribute("delete-recipient"));
                this.deleteRecipientById(event.target.getAttribute("delete-recipient"));
            }
            if (event.target.hasAttribute("history-recipient")) {
                // console.log(event.target.getAttribute("history-recipient"));
                this.historyRecipientById(event.target.getAttribute("history-recipient"));
                return;
            }
            if (event.target.hasAttribute("download-recipants-doc")) {
                // console.log(event.target.getAttribute("download-recipants-doc"));
                this.openDownloadModal(event.target.getAttribute("download-recipants-doc"));
                return;
            }
            if (event.target.hasAttribute("approve-recipient")) {
                this.approveRecipientByID(event.target.getAttribute("approve-recipient"));
            }
        });
    }

    approveRecipientByID(recipientId) {

        let user_local = JSON.parse(localStorage.getItem("user"));
        let roles = user_local.Roles
        let SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role=>{ return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });
    
        if(SYSTEM_DEFINED_UPSI_CHECKER.length<=0){
          alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
        }else{
            this.recipientService.addApproveRecipient(recipientId).subscribe((response)=>{
                if(!response.status){
                    alert("UPSI Recipient approved");
                }else{
                    alert("UPSI Recipient approval failed !");
                }
            })
        }
    }

    historyRecipientById(RecipientId) {

        let usersList = this.taskService.getUsersList();

        let recipientList = this.recipientService.getRecipientHistory(RecipientId);

        Observable.forkJoin([recipientList, usersList])
            .subscribe((response) => {
                // console.log('response', response)
                var recipientHistoryData;
                if (response[0].status == 0) {
                    recipientHistoryData = response[0].data
                } else {
                    recipientHistoryData = {};
                }
                var usersData;
                if (response[1].status == 0) {
                    usersData = response[1].result;
                } else {
                    usersData = {};
                }
                var recipientHisData = [];


                _.forEach(recipientHistoryData, function (recipient) {
                    var CreatedByUser = _.filter(usersData, ["_id", recipient.d.CreatedBy]);
                    _.assign(recipient, { CreatedByUserName: (CreatedByUser[0] != null || CreatedByUser[0] != undefined) ? (CreatedByUser[0].FirstName + " " + CreatedByUser[0].LastName) : "" })

                    var ModifiedByUser = _.filter(usersData, ["_id", recipient.d.ModifiedBy]);
                    _.assign(recipient, { ModifiedByUserName: (ModifiedByUser[0] != null || ModifiedByUser[0] != undefined) ? (ModifiedByUser[0].FirstName + " " + ModifiedByUser[0].LastName) : "" })

                    recipientHisData.push(recipient);
                })

                $("#reHistorytable").DataTable().destroy();
                this.recipientHistory = recipientHisData;


                this.dtHistoryTrigger.next();
                $('#historyModelr').modal('show');


            });




    }
    editRecipientByID(recipientId) {
        if(this.isMakerCheckerUsed){
            var user_local = JSON.parse(localStorage.getItem("user"));
            var roles = user_local.Roles
            var SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role=>{ return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });
        
            if(SYSTEM_DEFINED_UPSI_CHECKER.length<=0){
              alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
              return;
            }
        }
        this.router.navigate( [{ outlets: { 'structure-outlet': ['userMaster', 'upsirecipient', 'recipient', 'edit',recipientId] } }],
        { relativeTo: this.route.parent });
    }
    deleteRecipientById(recipientId) {
        this.recipientIdforDeleteRecipient = recipientId;
        $('#deleteRecipientConfirmation').modal('show');
    }

    searchData() {

        if (this.recipientName == null && this.recipientEmpCode == null && this.recipientDesignation == null
            && this.recipientUniqueIdentifier == '' && this.recipientDocument == null && this.recipientEmail == null && this.SearchDateFrom == null && this.SearchDateTo == null
            && !this.isShowUnapproved) {
            this.alert.success("Enter  one of search data.");
            return;

        }

        var paramData = {
            Name: (this.recipientName != null && this.recipientName.trim() != '' && _.size(this.recipientName.trim())) ? this.recipientName.trim().toLowerCase() : {},
            EmpCode: (this.recipientEmpCode != null && this.recipientEmpCode != '' && _.size(this.recipientEmpCode.trim())) ? this.recipientEmpCode.trim().toLowerCase() : {},
            Department: (this.recipientDesignation != null && this.recipientDesignation != '' && _.size(this.recipientDesignation.trim())) ? this.recipientDesignation.trim().toLowerCase() : {},
            Unique_Identifier_Type: (this.recipientUniqueIdentifier != null && this.recipientUniqueIdentifier.trim() != '' && _.size(this.recipientUniqueIdentifier.trim())) ? this.recipientUniqueIdentifier.trim() : {},
            Document_No: (this.recipientDocument != null && this.recipientDocument.trim() != '' && _.size(this.recipientDocument.trim())) ? this.recipientDocument.trim().toLowerCase() : {},
            email_id: (this.recipientEmail != null && this.recipientEmail.trim() != '' && _.size(this.recipientEmail.trim())) ? this.recipientEmail.trim().toLowerCase() : {},
            CreatedFrom: (this.SearchDateFrom != null && this.SearchDateFrom != '' && _.size(this.SearchDateFrom)) ? this.setDate(this.SearchDateFrom) : {},
            CreatedTo: (this.SearchDateTo != null && this.SearchDateTo != '' && _.size(this.SearchDateTo)) ? this.setDate(this.SearchDateTo) : {},
            isShowUnapproved : this.isShowUnapproved
        }
        this.getRecipientList(paramData);

    }

    clear() {
        var paramData = {}
        this.recipientName = null;
        this.recipientEmpCode = null;
        this.recipientDesignation = null;
        this.recipientUniqueIdentifier = '';
        this.recipientDocument = null;
        this.recipientEmail = null;
        this.SearchDateFrom = null;
        this.SearchDateTo = null;
        this.isShowUnapproved = false;
        this.isShowEncryptedPAN=false;
        this.getRecipientList(paramData);
    }

    deleteRecipient() {

        new Promise(resolve => this.recipientService.deleteRecipient(this.recipientIdforDeleteRecipient).subscribe((response) => {
            if (response.status == 1) {
                this.alert.error(response.message);

            } else {
                this.getRecipientList({});
                this.alert.success(response.message);

            }

        }))

    }

    upload() {
        var file = this.filesToUpload;
        if (file != undefined) {
            // console.log("file ", file)
            this.makeFileRequest(environment.pssServerUrl + "recipient/csvUplaodAddRecipient", [], file).then((result) => {
                $("#fileInput").val('');
                this.isUploadNotValid = true;
                if (result['status'] == 0) {

                    this.notinserteddata = result['data'];
                    $("#CsvUploadtable").DataTable().destroy();
                    // console.log(result['data'])
                    this.dtnotInsertdataTrigger.next();

                    if (_.size(result['data'])) {

                        $('#notInsertdata').modal('show');
                    }
                    else {
                        this.alert.success("All records are successfully inserted.");
                    }
                    this.getRecipientList({});

                }else{
                    this.alert.error("File is empty.");
                    this.getRecipientList({});
                }

            });
        } else {
            // console.log("file undefined")
        }
    }


    makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
        return new Promise((resolve, reject) => {
            var formData: any = new FormData();
            var xhr = new XMLHttpRequest();
            for (var i = 0; i < files.length; i++) {
                var newDate = Date.now();
                formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
            }
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        resolve(JSON.parse(xhr.response));
                    } else {
                        reject(xhr.response);
                    }
                }
            }
            xhr.open("POST", url, true);
            var token = localStorage.getItem('token')            
            xhr.setRequestHeader('x-access-token', token)
            xhr.setRequestHeader('userdetail', this.getUserDetail())
            xhr.setRequestHeader('pssdetail', localStorage.getItem("companyDetails"))
            xhr.send(formData);
        });
    }

    allExtensions()
    {
        return ["csv", "xlsx", "xls", "jpg", "jpeg", "png", "doc", "docx", "txt", "pdf", "ppt","pptx", "mp4","apk","bat","bin","cgi","com","exe","jar","py","wsf","aif","cda","iff","mid","midi","mp3","mpa","wav","wma","wpl","avi","flv","h264","m4v","mkv","mov","mpg","mpeg","rm","swf","vob","wmv","3g2","3gp","odt","msg","rtf","tex","wks","wps","wpd","ods","xlr","key","odp","pps","accdb","dat","db","dbf","log",
        "mdb","pdb","sav","sql","tar","bak","cab","cfg","cpl","cur","dll","dmp","drv","icns","ico","ini","lnk","msi","sys","tmp","asp","aspx","cer","cfm","cgi","pl","css","htm","html","js","jsp","part","php","rss","xhtml","ai","bmp","gif","ico","max","obj","ps","psd","svg","tif","tiff","3ds","3dm"];
                
    }

    isInArray(array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    }
    toggleSearchDiv() {
        this.isSearchDivVisible = !this.isSearchDivVisible;
      }

    fileChanged($event) {
        // console.log('file changed', $event.target.files[0])
        var filenameValidation = this.commonFunction.checkIfFileNameIsCorrect($event,$event)
        if (filenameValidation == "Valid") {
            if ($event.target.files[0] / (1024 * 1024) > (1024 * 1024)) {
                this.fileSizeError = true;
                this.isUploadNotValid = true;
            } else {
                var count=0;
                var self=this;
                // console.log('file changed', $event.target.files[0])
                var allowedExtensions = ["csv", "CSV", "xlsx", "XLSX"];
                var filename = $event.target.files[0].name;
                var checkFilesExtension=filename.toString().split('.').pop();
                // console.log(" checkFilesExtension : ====>  ", checkFilesExtension )
                this.fileExtension = filename.split('.');
            //    console.log("fileExtension", this.fileExtension);
    
                // this.fileExtension = filename.toString().split('.').pop();
                // console.log("filename", filename);
                // console.log("fileExtension", this.fileExtension);
    
                this.fileExtension.forEach(function(value, key) {
                    // console.log(key + ': ' + value);
                    if(self.isInArray(self.allExtensions(), value))
                    {
                        count++; 
                    }
                  });
        
                //   console.log('count : ',count);
                if (count==1 && self.isInArray(allowedExtensions, checkFilesExtension)) {
                    this.fileExtensionError = false;
                    this.fileSizeError = false;
                    this.isUploadNotValid = false;
                    this.filesToUpload = $event.target.files;
                } else {
                    this.fileExtensionError = true;
                    this.isUploadNotValid = true;
                }
            }
           
        }else{
            this.alert.error(filenameValidation);
        }
    }
   

    getUserDetail() {
        var user = JSON.parse(localStorage.getItem("user"));
        var resources = JSON.parse(localStorage.getItem("resources"));
        var companyDetails = JSON.parse(localStorage.getItem("companyDetailsGoveva"));
        var resourcesData = resources.filter(function (item) {
            return item.Menu === 'UPSI';
        })[0]

        var upsiAdmin;
        if (resourcesData) {
            upsiAdmin = (resourcesData['Menu']) ? true : false
        } else {
            upsiAdmin = false
        }
        var decrEmailId=this.commonFunction.decrypt(user.EmailId);
        var loginUser = {
            id: user._id,
            firstName: user.FirstName,
            lastName: user.LastName,
            upsiAdmin: upsiAdmin,
            // EmailId: user.EmailId,
            EmailId: decrEmailId,
            companyDetails: companyDetails,
            title: user.Title
        }
        return JSON.stringify(loginUser);
    }
    setDate(date) {
        if (date != "" && date != null) {
            return date.year + "-" + date.month + "-" + date.day;
        }
        return null;
    }
    getRecipientList(paramData) {
        // Prevent concurrent initialization
        if (this.isInitializingDataTable) {
            return;
        }
        
        var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
        paramData.companyID = companyDetails.companyID;
        var token = localStorage.getItem('token')
        var self = this;
        
        // Destroy existing DataTable if it exists to prevent duplicate requests
        if ($.fn.DataTable && $.fn.DataTable.isDataTable('#datatableMeeting')) {
            try {
                $('#datatableMeeting').DataTable().destroy();
            } catch (error) {
                console.error('Error destroying DataTable:', error);
            }
        }
        
        // Check if table element exists before initializing
        const tableElement = document.getElementById('datatableMeeting');
        if (!tableElement) {
            console.warn('Table element #datatableMeeting not found, retrying...');
            setTimeout(() => {
                this.getRecipientList(paramData);
            }, 100);
            return;
        }
        
        this.isInitializingDataTable = true;
        
        $('#datatableMeeting').DataTable({
            
            ajax: {
                // url: environment.pssUrl + "dataTable/sharer/" + JSON.parse(localStorage.getItem("companyDetails")).companyID,
                url: environment.pssServerUrl + "dataTable/recipient",
                type: 'post',
                data: paramData,
                headers: { "x-access-token": token },
                cache: true
            },
            columns: [{
                title: 'Name',
                width: "20%",
                render: function (data: any, type: any, full: any) {
                    return full.Name

                }
            },
            {
                title: 'Recipient Code',
                width: "15%",
                render: function (data: any, type: any, full: any) {
                    return full.EmpCode
                }
            }, {
                title: 'Company Name',
                width: "15%",
                render: function (data: any, type: any, full: any) {
                    return full.Department
                }
            }, {
                title: 'Unique Identifier Type',
                width: "20%",
                render: function (data: any, type: any, full: any) {

                    return full.Unique_Identifier_Type == 'Other' ? full.other_document_name : full.Unique_Identifier_Type
                }
            }, {
                title: "Document No",
                width: "20%",
                render: function (data: any, type: any, full: any) {
                    // For display, show masked value if encryption is enabled
                    if (type === 'display') {
                        return self.isShowEncryptedPAN ? '**********' : full.Document_No.toUpperCase();
                    }
                    // For export, return original unmasked value
                    return full.Document_No ? full.Document_No.toUpperCase() : '';
                }

            }, {
                title: "Email Id",
                width: "20%",
                render: function (data: any, type: any, full: any) {
                    if (type === 'display') {
                    const [username, domain] = full.email_id.split('@');
                    return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
                }
                // For export, return original unmasked email
                return full.email_id || '';
                }

            }, {
                title: 'Action',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    var buttonsText = '<div class="input-group">';
                    if(!full.IsCheckerApproved){
                        buttonsText = buttonsText + '<button type="button"  title="Approve" approve-recipient=' + full._id + ' class="btn-sm btn btn-success" ><span class="fa fa-check"  approve-recipient=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }
                    if (self.commonFunction.validateModulePermitions('UPSI Recipient', '/uspiRecipient/edit')) {
                        // return '<div class="input-group"><button type="button"  title="Edit"   update-recipient=' + full._id + ' class="btn-sm btn btn-warning" ><span class="fa fa-pencil"  update-recipient=' + full._id + '></span></button>&nbsp;&nbsp;<button   title="Delete" type="button" delete-recipient=' + full._id + ' class="btn-sm btn btn-danger" ><span class="icmn-bin"  delete-recipient=' + full._id + '></span></button>&nbsp;&nbsp;<button  type="button" title="History" history-recipient=' + full._id + ' class="btn-sm btn btn-warning" ><span class="icmn-history"  history-recipient=' + full._id + '></span></button></div>';
                        buttonsText =   buttonsText + '<button type="button"  title="Edit"   update-recipient=' + full._id + ' class="btn-sm1 btn btn-warning" ><span class="fa fa-pencil"  update-recipient=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }

                    if (self.commonFunction.validateModulePermitions('UPSI Recipient', '/uspiRecipient/delete')) {
                        buttonsText =   buttonsText + '<button   title="Delete" type="button" delete-recipient=' + full._id + ' class="btn-sm1 btn btn-danger" ><span class="icmn-bin"  delete-recipient=' + full._id + '></span></button>&nbsp;&nbsp;';
                    }

                    if (full.DocumentFile) {
                        buttonsText = buttonsText + '<button  type="button" title="download" download-recipants-doc="' + [full.DocumentFile] + '" class="btn btn-sm1 btn-primary"><span class="fa fa-download"  download-recipants-doc="' + [full.DocumentFile] + '"></span></button>&nbsp;&nbsp;';
                    }
                   
                    buttonsText =  buttonsText + '<button  type="button" title="History" history-recipient=' + full._id + ' class="btn-sm1 btn btn-warning" ><span class="icmn-history"  history-recipient=' + full._id + '></span></button></div>';

                    return buttonsText;

                }
            },
            {
                title: 'Mobile Number',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.ContactNumber

                }
            },
            {
                title: 'Tel Number',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.tele_Number

                }
            },
            {
                title: 'Address_1',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.Address_1

                }
            },
            {
                title: 'Address_2',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.Address_2

                }
            },
            {
                title: 'Address_3',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.Address_3

                }
            },
            {
                title: 'City',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.city

                }
            },
            {
                title: 'PIN',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return full.pin

                }
            },
            {
                title: 'Other Document Name',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return (full.other_document_name) ? full.other_document_name : "-"

                }
            },
            {

                title: 'Created Date',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return self.roundDigit(new Date(full.CreatedDate).getDate()) + '-' + (new Date(full.CreatedDate).getMonth() + 1) + '-' + new Date(full.CreatedDate).getFullYear() + ''

                }
            },
            {

                title: 'Document File',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    return (full.DocumentFile)?full.DocumentFile.substring(14):""

                }
            },{
              
                title: 'Modified Date',
                width: "10%",
                render: function (data: any, type: any, full: any) {
                    if(full.ModifiedDate){
                    return self.roundDigit(new Date(full.ModifiedDate).getDate()) + '-' + (new Date(full.ModifiedDate).getMonth() + 1) + '-' + new Date(full.ModifiedDate).getFullYear() + ''
                    }else{
                        return null
                    }
                }
            }
            ],
            processing: true,
            serverSide: false,
            scrollX: true,
            deferRender: true,
            stateSave: true,
            stateDuration: -1,
            scrollY: "420px",
            scrollCollapse: true,
            destroy: true,
            pagingType: 'full_numbers',
            paging: true,
            pageLength: 10,
            search: true,
            order: [0, 'asc'],
            columnDefs: [{ orderable: false, targets: [6] }, { className: "hide_col", targets: [7, 8, 9, 10, 11, 12, 13, 14, 15,16,17] }],
            lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
            dom: 'lBfrtip',//'Bfrtip',
            buttons: [
                {
                    text: '<i class="fa fa-files-o"></i> Export to Excel',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Recipient List',
                    title: 'Recipient List',
                    extend: 'excel',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 15,16,17],
                        orthogonal: 'export',
                        format: {
                          body: function ( data, row, column, node ) {
                            if (typeof data === 'string' && (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!"))) {
                                if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) {
                                  return data;
                                } else {
                                  return "'" + data + "'";
                                }
                              } else if (typeof data === 'number' || typeof data === 'boolean') {
                                // Handle numbers and booleans if needed
                                return data.toString();
                              } else {
                                return data;
                              }
                            
                            }
                        }
                    }
                },
                {
                    text: '<i class="fa fa-files-o"></i> Export to PDF',
                    className: 'btn btn-sm btn-warning export-btn',
                    filename: 'Recipient List',
                    title: 'Recipient List',
                    orientation: 'landscape',
                    extend: 'pdf',
                    pageSize: 'A3',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 7, 8, 9, 10, 11, 12, 13, 15,16,17],
                        orthogonal: 'export'
                    }
                }
            ],
            initComplete: function() {
                // Reset flag after DataTable is fully initialized
                self.isInitializingDataTable = false;
            }
        });
        this.response = false;
        // Remove ajax.reload() as it causes duplicate requests - DataTable already loads data on init
        // $('#datatableMeeting').DataTable().ajax.reload();
    }
    roundDigit(val) {

        var str = new String(val);

        if (str.length == 1) {
            return (0 + '' + val);
        } else {
            return parseInt(val);
        }
    }

    openDownloadModal(files){
        this.fileNameArray = files.split(',')
        $("#UpsiFileDownloadTitle").html("Attachments of Emails");
        $("#upsiDetailsFileDownloadDialog").modal('toggle');
    }
    
    
    downloadRecipentDoc(fileName){
        let token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "upsi/recipientDoc/" + fileName + "/" + token
    }

}
